var WDN = WDN || {};

if (typeof WDN.ViewedProducts === "undefined") {
  WDN.ViewedProducts = (function () {
    /* Recently viewed tracker */
    class ViewedProducts {
      constructor(id) {
        this.storageName = "viewed_products";
        this.storeType = "localStorage";
        this.limit = 50;
        this.list = [];

        this.initialLoad();
      }

      removeFromList(handle) {
        // remove current, to be added again, so it is the
        // most recently viewed item
        this.list.splice(this.list.indexOf(handle), 1);
      }

      saveList() {
        if (this.storeType == "localStorage") {
          localStorage.setItem(this.storageName, JSON.stringify(this.list));
        }
      }

      clear() {
        this.list = [];
      }

      cleanListToMaxLimit() {
        this.list = this.list.reverse().slice(0, this.limit - 1);
        this.list.reverse();
      }

      track(handle) {
        if (!handle || handle.length == 0) {
          return false;
        }

        if (this.list.indexOf(handle) > -1) {
          this.removeFromList(handle);
        }

        this.cleanListToMaxLimit();
        this.list.push(handle);
        this.saveList();

        return true;
      }

      initialLoad() {
        if (this.storeType == "localStorage") {
          if (!localStorage.getItem(this.storageName)) {
            return;
          }

          this.list = JSON.parse(localStorage.getItem(this.storageName));
        }
      }
    }

    // auto track product visits, based on attribute on page
    var productHistory = new ViewedProducts();
    var target = document.querySelector("[data-product-track]");

    if (target) {
      var handle = target.getAttribute("data-product-track");
      productHistory.track(handle);
    }

    return ViewedProducts;
  })();
}
